import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service';
import { CustomerFindResultModel, CustomerGiveawaysModel, CustomerModel, CustomerPhoneFindModel } from '@models/CustomerModel';
import { SharedService } from './shared.service';
import { Country } from '@shared/models/Enums';


@Injectable()
export class ApiCustomerService extends ApiBaseService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // Customers API //
    

    // GET: api/admin/customers/find-email/reads/v1
    findCustomerByEmail(email: string, isVerified: boolean = false): Promise<string> {

        return this.http.post(`${this.baseUrl}/api/admin/customers/find-email/reads/v1`, {email, isVerified}, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    return result;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información: ${errMsg}`));
                }
            );
    }

    // POST: api/admin/customers/find-phone/reads/v1
    findCustomerByPhone(phoneCountry: string, phone: string, isVerified: boolean = false): Promise<CustomerFindResultModel> {

        return this.http.post(`${this.baseUrl}/api/admin/customers/find-phone/reads/v1`, { phoneCountry, phone, isVerified }, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const customerResult = new CustomerFindResultModel(result);

                    return customerResult;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/customers/giveaways/find-phone/reads/v1
    findCustomerGiveawaysByPhone(customer: CustomerPhoneFindModel, country?: Country): Promise<CustomerGiveawaysModel> {

        return this.http.post(`${this.baseUrl}/api/admin/customers/giveaways/find-phone/reads/v1`, customer, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const companyCustomer = new CustomerGiveawaysModel(result);

                    return companyCustomer;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información: ${errMsg}`));
                }
            );

    }

    // POST: api/admin/customers/giveaways/find-phone/reads/v1 (sin sesión, raspadita pública)
    withoutSessionFindCustomerGiveawaysByPhone(customer: CustomerPhoneFindModel, country: Country): Promise<CustomerGiveawaysModel> {

        return this.http.post(`${this.baseUrl}/api/admin/customers/giveaways/find-phone/reads/v1`, customer, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    const companyCustomer = new CustomerGiveawaysModel(result);

                    return companyCustomer;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información: ${errMsg}`));
                }
            );
    }
}
